<template>
  <div class="w-full">
    <v-divider v-if="!VISAO_VERTICAL_ATIVA" />

    <div class="d-flex align-center w-full pt-2 pb-1">
      <v-icon size="21">mdi-format-list-bulleted</v-icon>
      <span class="font-weight-medium font-19 ml-1 text-no-wrap">Lista de produtos</span>

      <v-divider vertical class="ml-4" style="height: 40px" />

      <Ordenacao
        id_unico_preferencia="ORDENACAO_TABELA_LISTA_PRODUTOS_TELA_COMPRAS_GERAL"
        :itens="colunas_ordenacao"
        :abrir_dialog_ordenacao_count="abrir_dialog_ordenacao_count"
        @update:ordenacao="() => CALLBACK_RECARREGAR_TABELA_PRODUTOS()"
        @campos:ordenacao="ev => $emit('campos:ordenacao', ev)"
      />

      <div class="w-350 ml-4">
        <slot name="input-pesquisa">
          <v-text-field
            v-model="PESQUISA"
            hide-details
            outlined
            dense
            clearable
            label="Pesquisar"
            prepend-inner-icon="mdi-magnify"
            v-lazy-input:debounce="2500"
            @keydown.enter="ev => (PESQUISA = ev.target.value)"
          />
        </slot>
      </div>

      <div class="ml-auto mr-0">
        <slot name="append-lado-direito"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import Ordenacao from "@/components/utils/dataTable/Ordenacao.vue";
import {mapGetters} from "vuex";
import {colunas_ordenacao} from "@/components/compra/ProdutosGerais/ListaProdutos/Cabecalhos";

export default {
  name: "TopoGrid",
  components: {
    Ordenacao
  },
  props: {
    abrir_dialog_ordenacao_count: Number,
  },
  data: () => ({
    colunas_ordenacao,
  }),
  computed: {
    ...mapGetters({
      CALLBACK_RECARREGAR_TABELA_PRODUTOS: "CompraProdutosGerais/callbackRecarregarTabelaProdutos",
    }),
    PESQUISA: {
      get: function () {
        return this.$store.getters['CompraProdutosGerais/getPesquisa'];
      },
      set: function(valor) {
        this.$store.dispatch('CompraProdutosGerais/setPesquisa', valor || '');
      }
    },
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    },
  }
}
</script>

<style scoped>

</style>
